import {apiHelper} from "../redux/apiHelper"
export const getCmsLabSection=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-laboratory-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsLabSection=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-laboratory-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsLabSection=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-laboratory-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsLabSectionById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-laboratory-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsLabSectionById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-laboratory-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}